import React, { useState, useEffect } from "react";
import { PlusCircle, Trash2 } from "lucide-react";
import Navbar from "./Navbar";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import axios from "axios";

const AmbulanceManager = () => {
  const [ambulances, setAmbulances] = useState([]);
  const [newAmbulances, setNewAmbulances] = useState([{ name: "", phone: "", location: "" }]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [search, setSearch] = useState("");

  const fetchAmbulance = async () => {
    try {
      const res = await axios.get("https://www.careplus.gopillz.com/new_add-Ambulance", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setAmbulances(res.data.ambulance_list);
    } catch (err) {
      console.error("Error fetching ambulance", err);
    }
  };


  // Fetch ambulance data from API
  useEffect(() => {
    fetchAmbulance()
    
  }, []);

  const handleChange = (index, field, value) => {
    const updated = [...newAmbulances];
    updated[index][field] = value;
    setNewAmbulances(updated);
  };

  const addAmbulanceField = () => {
    setNewAmbulances([...newAmbulances, { name: "", phone: "", location: "" }]);
  };

  const removeAmbulanceField = (index) => {
    const updated = [...newAmbulances];
    updated.splice(index, 1);
    setNewAmbulances(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      name: newAmbulances.map(a => a.name),
      phone: newAmbulances.map(a => a.phone),
    };

    try {
      const res = await axios.post("https://www.careplus.gopillz.com/new_add-Ambulance", payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setMessage(res.data.message);
      setAmbulances(prev => [...prev, ...newAmbulances]);
      setNewAmbulances([{ name: "", phone: ""}]);
      fetchAmbulance()
    } catch (err) {
      setMessage("Error submitting data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filteredAmbulances = ambulances.filter((a) =>
    a.name.toLowerCase().includes(search.toLowerCase()) ||
    a.ambulance_number.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="bg-blue-50 min-h-screen">
      <Navbar />
      <div className="flex justify-center items-start px-4 pt-24 pb-10 min-h-screen">
        <div className="w-full max-w-6xl space-y-10">
          {/* Header */}
          <div className="text-center">
            <h1 className="text-4xl font-bold text-blue-700 mb-2">🚑 Ambulance Manager</h1>
            <p className="text-gray-600">View and manage ambulance service providers</p>
          </div>

          {/* Search Box */}
          <div className="flex justify-center mb-6">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by ambulance name or number..."
              className="w-full max-w-md px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Ambulance List */}
          <section className="bg-white rounded-2xl shadow-md p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Available Ambulances</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredAmbulances.length === 0 ? (
                <p className="text-gray-500 col-span-full">No matching ambulances found.</p>
              ) : (
                filteredAmbulances.map((ambulance, index) => (
                  <div
                    key={index}
                    className="bg-red-100 border border-red-200 rounded-xl p-4 hover:shadow-lg transition"
                  >
                    <h3 className="text-lg font-semibold text-red-900 mb-1">{ambulance.name}</h3>
                    <p className="text-sm text-red-800">📞 {ambulance.ambulance_number}</p>
                  </div>
                ))
              )}
            </div>
          </section>

          {/* Add Ambulance Form */}
          <section className="bg-white rounded-2xl shadow-md p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">➕ Add Ambulance Service</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              {newAmbulances.map((ambulance, index) => (
                <div
                  key={index}
                  className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center"
                >
                  <input
                    type="text"
                    placeholder="Service Name"
                    value={ambulance.name}
                    onChange={(e) => handleChange(index, "name", e.target.value)}
                    className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                    required
                  />
                  <PhoneInput
                    country="in"
                    enableSearch={true}
                    disableDropdown={false}
                    value={ambulance.phone}
                    onChange={(value) => handleChange(index, "phone", value)}
                    inputClass="!w-full !px-4 !py-2 !text-sm !border !border-gray-300 !rounded-lg !bg-gray-50"
                    buttonClass="!border-gray-300"
                    containerClass="!w-full"
                  />
                  {newAmbulances.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeAmbulanceField(index)}
                      className="text-red-500 hover:text-red-700 text-sm mt-2 sm:mt-0"
                    >
                      <Trash2 className="w-5 h-5" />
                    </button>
                  )}
                </div>
              ))}

              <div className="flex flex-wrap items-center gap-4">
                <button
                  type="button"
                  onClick={addAmbulanceField}
                  className="flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition"
                >
                  <PlusCircle className="w-5 h-5" /> Add Another
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
                >
                  {loading ? "Saving..." : "Submit Ambulances"}
                </button>
              </div>

              {message && (
                <p className="text-sm font-medium mt-2 text-green-600">{message}</p>
              )}
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AmbulanceManager;
